<template>
  <div>
    <Card>
    </Card>
  </div>
</template>
<script>
// import Tables from '_c/tables'
// import { getLoginHistoryList } from '@/api/data'
export default {
  name: 'oss_setting_page',
  components: {

  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>
<style scoped>
</style>
